import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DefaultButton from "../components/buttons/DefaultButton";
import { AppVariablesService } from "../services/AppVariablesService";

function TermosDeUso() {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  const [terms, setTerms] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const appVariablesService = new AppVariablesService();

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await appVariablesService.find();
        if (response?.config?.termsOfUseUrl) {
          setTerms(response.config.termsOfUseUrl);
        }
      } catch (err) {
        setError("Erro ao carregar os Termos de Uso.");
      } finally {
        setLoading(false);
      }
    };

    fetchTerms();
  }, []);

  const handleAccept = (e) => {
    e.preventDefault();
    if (accepted) {
      localStorage.setItem("termsAccepted", "true");
      const roleType = localStorage.getItem("roleType");

      if (roleType === "ADMIN") {
        window.location.href = "/admin";
        return;
      }

      window.location.href = "/";
    }
  };

  if (loading) {
    return <div className="text-center mt-5">Carregando Termos de Uso...</div>;
  }

  return (
    <div className="container vh-100 d-flex flex-column justify-content-center align-items-center">
      <div className="text-center" style={{ width: "100%" }}>
        <h2>TERMOS DE USO</h2>

        <div
          style={{
            maxHeight: "400px",
            overflowY: "auto",
            border: "1px solid #ccc",
            width: "100%",
            padding: "10px",
            marginBottom: "20px",
            textAlign: "left",
            whiteSpace: "pre-line", // Ensures line breaks are shown
          }}
          dangerouslySetInnerHTML={{ __html: terms }}
        />

        <label>
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
          />{" "}
          Li e estou de acordo com os Termos de Uso
        </label>

        <div className="mt-3">
          <DefaultButton onClick={handleAccept} disabled={!accepted}>
            Continuar
          </DefaultButton>
        </div>
      </div>
    </div>
  );
}

export default TermosDeUso;
